/*
    [pageName]: [

    ]
*/

import { ConstructionOutlined } from "@mui/icons-material";
import { PATHS } from "Utils/PagePaths";
import { getPageMatches, getPublicPageNameFromPath } from "Utils/utilityFunctions";



export const getPathCrumbs = (path, customCrumbs) => {
    //console.log(customCrumbs);
    var current = path;

    var publicName = getPublicPageNameFromPath(path);


    var matchData = null;
    if(publicName==null){
        matchData = getPageMatches(path);
        
        if(matchData!=null){
            publicName = getPublicPageNameFromPath(matchData.pattern.path);
            path = matchData.pattern.path;
        }
    }

    const segments = path.split('/').filter(segment => segment !== '');
    
    if (publicName == null) {
        return [];
    }
    if (publicName == 'Sign In' || publicName == 'Homepage') {
        return [];
    }

    var homeSegment = {
        name: 'Home',
        path: PATHS.public.Homepage
    };

    if (segments != null && segments.length < 1) {
        //console.log("Less than 1");
        return [
            homeSegment
        ];
    }
    else if (segments != null && segments.length == 1) {
        //console.log("Only 1");
        return [
            homeSegment,
            {
                name: publicName,
                path: PATHS.public[publicName]
            }
        ]
    }
    else {
        //console.log("More than 1");
        var arr = [
            homeSegment
        ];
        var tempPath = "";
        for (var x = 0; x < segments.length; x++) {
           
            tempPath = tempPath + "/" + segments[x];

            if(segments[x].startsWith(":")){
                //console.log(getPageMatches(tempPath)); 
                if(x==segments.length-1){
                   
                    var matchData = getPageMatches(tempPath);

                    if(matchData!=null){
                        publicName = getPublicPageNameFromPath(matchData.pattern.path);
                        arr.push({
                            name: publicName,
                            path: current
                        });
                    }
                }
            }
            else{
                // var matchData = getPageMatches(tempPath);
                // console.log(matchData);
                // if(matchData!=null){
                //     publicName = getPublicPageNameFromPath(matchData.pattern.path);
                //     console.log(publicName);
                //     path = matchData.pattern.path;
                //     console.log(path);
                // }
                var name = getPublicPageNameFromPath(tempPath);
                
                if(name!=null && PATHS.public[name]!=null){
                    arr.push({
                        name: name,
                        path: PATHS.public[name]
                    });
                }
                
            }
            
           
            
        }
        if(customCrumbs!=null){
            arr.splice(arr.length-1,0,{
                name: customCrumbs.value,
                path: customCrumbs.path,
                state: customCrumbs.state
            });
            //console.log(customCrumbs, arr);
        }
       
        
        //arr.push(customCrumbs);
        return arr;
    }

}

export const BREADCRUMBS = {
    "Homepage": null,
    "Sign In": null,

    "Become a PSO": {
        path: PATHS.public["Become a PSO"]
    },
    "User Account Types": {
        path: PATHS.public["User Account Types"]
    },

    "Current Common Formats": {
        path: PATHS.public["Current Common Formats"]
    },
    "Explore Common Format Data Elements": {
        path: PATHS.public["Explore Common Format Data Elements"]
    },
    "Data Element Detail": {
        path: PATHS.public["Data Element Detail"]
    },
    "Retired Common Formats": {
        path: PATHS.public["Retired Common Formats"]
    },
    "Community Pharmacy": {
        path: PATHS.public["Community Pharmacy"]
    },
    "Diagnostic Safety": {
        path: PATHS.public["Diagnostic Safety"]
    },
    "Hospital Version 1.2": {
        path: PATHS.public["Hospital Version 1.2"]
    },
    "Hospital Version 2.0": {
        path: PATHS.public["Hospital Version 2.0"]
    },
    "Nursing Home": {
        path: PATHS.public["Nursing Home"]
    },
    "Surveillance - Hospital": {
        path: PATHS.public["Surveillance - Hospital"]
    },

    "Submit Data": {
        path: PATHS.public["Submit Data"]
    },
    "Learn from the Data": {
        path: PATHS.public["Learn from the Data"]
    },
    "Get Help": {
        path: PATHS.public["Get Help"]
    },
    "About PSOPPC": {
        path: PATHS.public["About PSOPPC"]
    },
    "Search": {
        path: PATHS.public.Search
    },
    "Data Security": {
        path: PATHS.public["Data Security"]
    },
    "External Link Disclaimer": {
        path: PATHS.public["External Link Disclaimer"]
    },
    "Terms of Use": {
        path: PATHS.public["Terms of Use"]
    },
    "Accessibility": {
        path: PATHS.public.Accessibility
    },
    "Site Map": {
        path: PATHS.public["Site Map"]
    },
    "Privacy Policy": {
        path: PATHS.public["Privacy Policy"]
    },
    "Educational Briefs": {
        path: PATHS.public["Educational Briefs"]
    },
}